@if(isLoading) {
<div class="loading-overlay">
  <div class="loading-spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>
}

<div class="main-wrapper">
  <div class="content">
    <div class="form-container">
      <img
        src="assets/svg/logos/saude_conectada_logo.svg"
        alt="Logo Saúde Integrada"
        class="logo"
      />

      <div class="texts">
        <h2>Esqueceu sua senha?</h2>
        <p>
          Insira o endereço de e-mail vinculado à sua conta do
          <b>Saúde Conectada</b> e enviaremos um código de acesso.
        </p>
      </div>

      <form
        [formGroup]="recuperarSenhaFormGroup"
        (ngSubmit)="enviarCodigo()"
        class="form-fields"
      >
        <mat-form-field
          appearance="outline"
          class="email-form-field"
          color="warn"
        >
          <mat-label>E-mail</mat-label>
          <input matInput formControlName="email" type="email" required />
          <mat-error *ngIf="emailControl.hasError('required')"
            >O e-mail é obrigatório.</mat-error
          >
          <mat-error
            *ngIf="emailControl.hasError('email') && !emailControl.hasError('required')"
          >
            Formato de e-mail inválido.
          </mat-error>
          <mat-error
            *ngIf="emailControl.hasError('notFound')"
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 8px;
              margin-top: 8px;
            "
          >
            <img src="assets/svg/icons/warning.svg" alt="" /> E-mail não
            cadastrado.
          </mat-error>
        </mat-form-field>

        <button
          mat-raised-button
          color="primary"
          class="submit-button"
          type="submit"
          [disabled]="recuperarSenhaFormGroup.invalid"
        >
          Enviar código
        </button>
      </form>

      <div class="return" (click)="voltarParaLogin()">
        <img src="assets/svg/icons/arrow_left.svg" alt="" />
        <p>Voltar para login</p>
      </div>

      <img
        src="assets/svg/logos/sesi_logo.svg"
        alt="Logo SESI"
        class="logo-sesi"
      />
    </div>
  </div>
</div>
